<template>
  <div class="nav-bar-item">
    <div v-if="loginIn" class="wx-code-popover">
      <el-popover
        :placement="placement"
        :width="width"
        :trigger="trigger">
        <div class="wx-img">
          <el-image
            class="img"
            :src="codeUrl"
          />
          <div class="content">{{ content }}</div>
        </div>
        <slot name="reference" slot="reference">
          <div class="icon-text">
            <i class="icon-link"></i>
            <span>车务助手小程序</span>
          </div>
        </slot>
      </el-popover>
    </div>
    <div v-else class="wx-code-popover_login">
      <el-popover
        :placement="placement"
        :width="width"
        :trigger="trigger"
        offset='-100'>
        <div class="wx-img">
          <el-image
            class="img"
            :src="codeUrl"
          />
          <div class="content">{{ content }}</div>
        </div>
        <div name="reference" slot="reference">
          <div class="icon-text icon-text-login">小程序</div>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WxCodePopover',
  props: {
    loginIn: {
      type: Boolean,
      default: true,
    },
    codeUrl: {
      type: String,
      default: require('@/assets/img/QRCode.png'),
    },
    content: {
      type: String,
      default: '微信扫一扫 使用小程序',
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    width: {
      type: String,
      default: '136px',
    },
  },
  data() {
    return {
    }
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
.nav-bar-item {
  margin: 12px 0;
  padding: 0 8px;
}
.wx-code-popover_login {
  cursor: pointer;
  color: #999;
  position: fixed;
  right: 10px;
  bottom: 100px;
  width: 52px;
  height: 80px;
  border-radius: 100px;
  background-color: #fff;
  margin-left: 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}
::v-deep .el-popover__reference-wrapper {
  width: auto;
  height: 100%;
  margin-left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
::v-deep .el-popover {
  min-width: 136px;
}
.wx-img {
  display: flex;
  flex-flow: column;
  align-items: center;
  .img {
    width: 160px;
    height: 160px;
    padding-bottom: 10px;
  }
  .content {
    font-size: 12px;
    color: #3D3D3D;
  }
}
.icon-text {
  font-size: 14px;
  display: flex;
  align-items: center;
  .icon-link {
    display: inline-block;
    background-image: url('../../assets/img/xiaochengxu.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 17px;
    height: 17px;
    margin-right: 4px;
  }
  &:hover {
    .icon-link {
      background-image: url('../../assets/img/xiaochengxu-h.png');
    }
  }
}
.icon-text-login{
  border-radius: 100px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  padding-top: 4px;
  text-align: center;
  line-height: 1;
  font-size: 12px;
  color: #606266;
  &::before {
    content: '';
    width: 22px;
    height: 22px;
    background-image: url('../../assets/img/xiaochengxu.png');
    background-size: 22px 22px;
    background-repeat: no-repeat;
    background-position: center;
    flex: 0 0 22px;
  }
  &:hover{
    color: #276BEC;
    &::before {
      background-image: url('../../assets/img/xiaochengxu-h.png');
    }
  }
}
</style>
